<template>
  <div>
    <v-text-field
      :id="id"
      v-model="password"
      :name="name"
      :type="hide ? 'password' : 'text'"
      :label="label"
      :rules="!disableRules ? [validPassword] : []"
      :append-icon="hide ? visibilityIconOn : visibilityIconOff"
      :error="error"
      :hint="hint"
      validate-on-blur
      @click:append="() => { hide = !hide }"
      @input="update()"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @keyup.enter="$emit('keyboard-enter')"
    />
    <v-text-field
      v-if="confirmation"
      :id="confirmationId"
      v-model="passwordConfirmation"
      :name="confirmationName"
      :type="confirmationHide ? 'password' : 'text'"
      :label="confirmationLabel"
      :rules="[validPasswordConfirmation]"
      :append-icon="confirmationHide ? visibilityIconOn : visibilityIconOff"
      :error="error"
      hint="Re-enter password"
      validate-on-blur
      @click:append="() => { confirmationHide = !confirmationHide }"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @keyup.enter="$emit('keyboard-enter')"
    />
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'Password'
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hint: {
      type: String,
      required: false,
      default: ''
    },
    disableRules: {
      type: Boolean,
      required: false,
      default: false
    },
    confirmation: {
      type: Boolean,
      required: false,
      default: false
    },
    confirmationId: {
      type: String,
      required: false,
      default: 'password-confirmation'
    },
    confirmationName: {
      type: String,
      required: false,
      default: 'password-confirmation'
    },
    confirmationLabel: {
      type: String,
      required: false,
      default: 'Password Confirmation'
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    visibilityIconOn: {
      type: String,
      required: false,
      default: 'visibility'
    },
    visibilityIconOff: {
      type: String,
      required: false,
      default: 'visibility_off'
    }
  },

  data () {
    return {
      password: null,
      passwordConfirmation: null,
      errors: [],
      validate: false,
      hide: true,
      confirmationHide: true
    }
  },

  watch: {
    value (newVal) {
      this.password = newVal
    }
  },

  created () {
    this.password = this.value
  },

  methods: {
    update () {
      this.$emit('input', this.password)
    },
    validPassword () {
      if (this.password.length > 0) {
        this.errors = []
        this.validatePasswordLength()
        this.validatePasswordLowercase()
        this.validatePasswordUppercase()
        this.validatePasswordDigit()

        return this.errors.length ? `Password must ${this.errors.join(', ')}` : true
      } else {
        return true
      }
    },
    validPasswordConfirmation () {
      return this.password !== this.passwordConfirmation ? 'Passwords do not match' : true
    },
    validatePasswordLength () {
      if (this.password.length < 9) {
        this.errors.push('have 9 or more characters')
      } else if (this.password.length > 60) {
        this.errors.push('be less than 60 characters')
      }
    },
    validatePasswordLowercase () {
      if (/^[^a-z]+$/.test(this.password)) {
        this.errors.push('contain one or more lowercase characters')
      }
    },
    validatePasswordUppercase () {
      if (/^[^A-Z]+$/.test(this.password)) {
        this.errors.push('contain one or more uppercase characters')
      }
    },
    validatePasswordDigit () {
      if (/^[^\d]+$/.test(this.password)) {
        this.errors.push('contain at least one digit')
      }
    }
  }
}
</script>

<style scoped>
</style>
